import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { ReactComponent as Warn } from '@/assets/img/warn.svg';
import { isEmpty, cloneDeep } from 'lodash';
import Validator from '@/utils/validator';
import { Style } from '@/components/style';
import ServeType from '@/constants/ServeType';
import {
  setUberDirectApiError,
  setStructuredAddress,
} from '@/actions/uberDirect/uberDirectAction';

const { alertColor, gray3Color, blackColor } = new Style().getUiConfig();
function AddressDetails({ addressRef, street, setStreet, selectedServeType }) {
  const intl = useIntl();
  const dispatch = useDispatch<any>();
  // const placeholder = intl.formatMessage({
  //   id: 'cart.memberpoint.earn.point.by.phone',
  // });
  const [isVaild, setIsVaild] = useState(true);
  const [vaildatorMessage, setVaildatorMessage] = useState('');
  // const selectedServeType = useSelector<RootStateOrAny, any>(
  //   (state) => state.modeReducer.serveType
  // );
  const structuredAddress = useSelector(
    (state: RootStateOrAny) => state.uberDirectReducer.structuredAddress
  );
  const uberDirectErrorMsg = useSelector<RootStateOrAny, any>(
    (state) => state.uberDirectReducer.errorMsg
  );
  const placeholder = intl.formatMessage({
    id: 'delivery.placeholder.address.msg',
  });

  const updateStructAddress = (streetValue) => {
    const tempStructAddress = cloneDeep(structuredAddress);
    if (isEmpty(tempStructAddress)) return;
    tempStructAddress.street_address[0] = streetValue;

    dispatch(setStructuredAddress(tempStructAddress));
  };

  const handleAddressChange = () => {
    setStreet(addressRef.current.value);
    updateStructAddress(addressRef.current.value);
    if (uberDirectErrorMsg) dispatch(setUberDirectApiError(null));
  };

  useEffect(() => {
    if (selectedServeType !== ServeType.DELIVERY) return;
    if (selectedServeType !== ServeType.DELIVERY) {
      setIsVaild(true);
      setVaildatorMessage('');
      return;
    }

    if (uberDirectErrorMsg) {
      setIsVaild(false);
      if (uberDirectErrorMsg === 'address_empty') {
        setVaildatorMessage(
          intl.formatMessage({
            id: 'delivery.please.input.address',
          })
        );
      } else {
        setVaildatorMessage(
          intl.formatMessage({
            id: `uberDirect.error.${uberDirectErrorMsg.message}`,
          })
        );
      }
      return;
    }
    if (street === null) return;

    const isAddressValid = Validator.addressValidator(street, true);
    setIsVaild(isAddressValid);
    if (isEmpty(street)) {
      setVaildatorMessage(
        intl.formatMessage({
          id: `delivery.please.input.address`,
        })
      );
    }
  }, [addressRef.current?.value, uberDirectErrorMsg]);

  return (
    <div>
      <div className="d-flex justify-content-center">
        <input
          style={{
            marginTop: '10px',
            width: '100%',
            height: '42px',
            fontSize: '16px',
            borderRadius: '10px',
            border: `1px solid ${gray3Color}`,
            color: `${blackColor}`,
            paddingLeft: '10px',
          }}
          data-testid="address"
          id="address"
          ref={addressRef}
          type="text"
          placeholder={placeholder}
          onChange={() => handleAddressChange()}
          value={street}
        />
      </div>
      {!isVaild && (
        <div
          className="d-flex align-items-center"
          style={{
            color: alertColor,
            fontSize: '12px',
            margin: '5px 0px 10px 0px',
          }}
        >
          <Warn />
          {vaildatorMessage}
        </div>
      )}
    </div>
  );
}

AddressDetails.defaultProps = {
  street: null,
};

AddressDetails.propTypes = {
  street: PropTypes.string,
  setStreet: PropTypes.func.isRequired,
  addressRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    .isRequired,
  selectedServeType: PropTypes.string,
};

export default AddressDetails;
